import type { To } from 'react-router'

export type EmbeddedRoute = {
  web: To
  embedded: To
}

export const EmbeddedRoutes = {
  chatEditing: (): EmbeddedRoute => {
    return {
      web: '/generator/chat-editing',
      embedded: '/chat-editing',
    }
  },
  chatEditingWorkspaceCreator: (mediaId?: string): EmbeddedRoute => {
    if (mediaId) {
      return {
        web: `/generator/chat-editing/creator?mediaId=${mediaId}`,
        embedded: `/chat-editing/creator?mediaId=${mediaId}`,
      }
    }

    return {
      web: '/generator/chat-editing/creator',
      embedded: '/chat-editing/creator',
    }
  },
  chatEditingWorkspace: (workspaceId: string): EmbeddedRoute => {
    return {
      web: `/generator/chat-editing/workspace/${workspaceId}`,
      embedded: `/chat-editing/workspace/${workspaceId}`,
    }
  },
}
